export class Unit {
    constructor(
      public id: string,
      public name: string,
      public buildings: any[],
      public description?: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/units/shared/unit.model.ts